let bannerBound = false;

function showUpdateBanner() {
  const banner = document.getElementById("sw-update-banner");
  if (!banner) return;

  banner.style.display = "flex";
  requestAnimationFrame(() => banner.classList.add("visible"));

  if (bannerBound) return;
  bannerBound = true;

  document.getElementById("sw-update-btn")?.addEventListener("click", () => {
    window.location.reload();
  });

  document.getElementById("sw-dismiss-btn")?.addEventListener("click", () => {
    banner.classList.remove("visible");
    setTimeout(() => (banner.style.display = "none"), 300);
  });
}

async function unregisterServiceWorkers() {
  if (!("serviceWorker" in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));

  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  }
}

export async function setupServiceWorker() {
  if (import.meta.env.DEV) {
    await unregisterServiceWorkers();
    return;
  }

  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker.register("./sw.js");

  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type === "NEW_VERSION_AVAILABLE") {
      showUpdateBanner();
    }
  });
}
